import React from 'react'
import { hot } from 'react-hot-loader'
import Theme from 'docz-theme-default'

const Root = () => <Theme />

export default hot(module)(Root)
